import { Navigate, createFileRoute } from "@tanstack/react-router";

/* The global ladder editor is gone (2026-11-02): a ladder is part of the supervision policy a
 * deployment pins, and is revised on that robot's page (Supervision, Revise). Every old ladder
 * address lands on the project's deployed robots, where each robot's page carries it. */
export const Route = createFileRoute("/_console/p/$org/$project/deploy/ladders/$")({
  component: LaddersMoved,
});

function LaddersMoved() {
  const { org, project } = Route.useParams();
  return <Navigate to="/p/$org/$project/deploy" params={{ org, project }} replace />;
}
